import { connect } from "react-redux";
import { PageLibraryFavorite } from "senac-components";
import { commonSlice, contentSlice } from "../store/reducers";
import { RootState, AppDispatch } from "../store";
import {
  Content,
  ContentOptionDetail,
  ContentOptionDownload,
  ContentOptionDownloaded,
  ContentOptionFavorite,
  ContentOptionFavorited,
  ContentOptionReadingList,
  ContentReference,
  MenuOptions,
  PageHeaderOptionItem,
  PageLibraryHeaderOptionItem,
} from "senac-components/dist/pages/Mobile/PageInterfaces";
import {
  PageLibraryFavoritePropsDispatch,
  PageLibraryFavoritePropsState,
} from "senac-components/dist/pages/Mobile/PageLibraryFavorite";
import {
  FavoritesInternalTag,
  deleteContentReference,
  downloadContentReference,
  insertInFavorite,
  removeFromFavorite,
} from "../store/reducers/userDataSlice";
import { showContentDetail } from "../store/reducers/contentSlice";
import { filterContent } from "../store/reducers/common";

const mapState = (state: RootState) => 
{
  var inMobile = state.commonState.runningInMobile;
  var allContents = state.contentState.allContents;

  var data = state.userDataState.userData.filter(p=> p.tags && p.tags.length > 0 && p.targetType == "ManagedContent" && p.contextType == "ManagedContent" && p.tags.find(t=> t.name === FavoritesInternalTag) != null);
  var uniqueTags = data.map(p=>  p.tags ?? []).reduce((p, c)=>  [...new Map([...c, ...p].map(p=> [p.uid, p])).values()], []).filter(p=> p.name == FavoritesInternalTag);
  var remoteContents = data.filter(p=> p.tags && p.tags.filter(t=> uniqueTags.find(ut=> ut.uid == t.uid)).length > 0);
  var contentsUids = [... new Map(remoteContents.map(p=> [p.contextUid, p.contextUid])).values()];
  var contents = contentsUids.map(p=> allContents.find(c=> c.uid == p)).filter(p=> p) as Content[];

  // var data = state.userDataState.userData.filter(p=> p.tags && p.tags.length > 0 && p.targetType == "ManagedContent" && p.contextType == "ManagedContent");
  // var uniqueTags = data.map(p=>  p.tags ?? []).reduce((p, c)=>  [...new Map([...c, ...p].map(p=> [p.uid, p])).values()], []).filter(p=> p.name == FavoritesInternalTag);
  // var remoteContents = data.filter(p=> p.tags && p.tags.filter(t=> uniqueTags.find(ut=> ut.uid == t.uid)).length > 0);
  // var contentsUids = [... new Map(remoteContents.map(p=> [p.contextUid, p.contextUid])).values()];
  // var contents = contentsUids.map(p=> allContents.find(c=> c.uid == p)).filter(p=> p) as Content[];

  var favorites = contents?.map((p) => p.uid) ?? [];
  var downloads: string[] | undefined = undefined;

  if (inMobile) {
    downloads = state.contentState.allContents.filter(p=> p.references?.find(r=> r.downloadProgress && r.downloadProgress > 0) != undefined).map(p=> p.uid);
  }

  console.log("favoo", contents);

  let result: PageLibraryFavoritePropsState = {
    contentsFavorited: favorites,
    contentsDownloaded: downloads,
    contents: contents,
  };

  return result;
};

const mapDispatch = (dispatch: AppDispatch) => {
  //Ação inicial:
  // dispatch(contentSlice.actions.changeState('initializing'));

  const result: PageLibraryFavoritePropsDispatch = {
    onSelectedContentOption: (
      content: Content,
      option: PageLibraryHeaderOptionItem
    ) => {
      console.log(option);
      switch (option) {
        case ContentOptionFavorited: {
          dispatch(removeFromFavorite(content));
          break;
        }
        case ContentOptionFavorite: {
          dispatch(insertInFavorite(content));
          break;
        }
        case ContentOptionDetail: {
          dispatch(showContentDetail(content.uid));
          break;
        }
        case ContentOptionReadingList: {
          dispatch(contentSlice.actions.goToContentInfo(option));
          break;
        }
      }
    },
    onOpenContent: (data: Content) => dispatch(showContentDetail(data.uid)),
    onSelectedHeaderBack: () => dispatch(commonSlice.actions.backPage()),
    onSelectedHeaderMenuOption: (option: PageLibraryHeaderOptionItem) =>dispatch(commonSlice.actions.goToLibraryOption(option)),
    onSelectedNavigationPageOption: (option: MenuOptions) => dispatch(commonSlice.actions.goToPage(option)),
    onDeleteContent: (reference: ContentReference) => reference?.uid && dispatch(deleteContentReference(reference.uid)),
    onDownloadContent: (reference: ContentReference) => reference?.uid && dispatch(downloadContentReference(reference.uid)),
    onChangeFilter: (filter) => {
      if (filter.query == undefined) return;
      dispatch(filterContent({ query: filter.query }));
    },
  };

  return result;
};

const WPageLibraryFavorite = connect(
  mapState,
  mapDispatch
)(PageLibraryFavorite);

export { WPageLibraryFavorite };
